import { React, useRef } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import { ReactComponent as SearchIcon } from '../../../image/Searching.svg';

export default function SearchInput(props) {
	const { value, setValue, placeholder, width } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

	const inputRef = useRef();

	function handleClick(e) {
	}

	function handleChange(e) {
		setValue(e.target.value);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {
	}

	return (
    <Wrapper width={width}>
      <IconWrapper>
        <StyledSearchIcon width={24} height={24} lineColor={theme.line} />
      </IconWrapper>
      <Input
        ref={inputRef}
        placeholder={placeholder}
        value={value}
        onClick={handleClick}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
    </Wrapper>
  )
}

const StyledSearchIcon = styled(SearchIcon)`
  & path {
    fill: ${props => props.lineColor};
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;

  width: ${props => props.width ? `${props.width}px` : '495px'};
  height: 36px;
`;

const IconWrapper = styled.div`
  position: absolute;
  left: 10px;

  display: flex;
  justify-content: center;
  align-items: center;

  pointer-events: none;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 12px;
	line-height: 20px;

  padding: 0 0 0 43px;
  width: calc(100% - 38px);
  height: 34px;

	outline: none;
  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
  
	color: ${props => props.theme.text};

	&::placeholder {
    color: ${props => props.theme.line};
	}

  transition: all 0.3s ease-in-out;
`;